var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProfilearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.645,
    height: 5.635,
    viewBox: "0 0 9.645 5.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #3354b4;\r\n        stroke-width: 1.7px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_profilearrow",
    className: "cls-1",
    d: "M2634.392-1206.576l4.265,3.74,4.247-3.866",
    transform: "translate(-2633.832 1207.329)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfilearrow);
export default __webpack_public_path__ + "static/media/ic_profilearrow.9d593ee094dc5673f850c90b2e8cf6c6.svg";
export { ForwardRef as ReactComponent };